import { datalayerInstance } from "../app/datalayer";
import bootstrap from "./bootstrap";

window.gap.datalayer = datalayerInstance();

/* eslint @typescript-eslint/no-empty-function: "off" */
bootstrap(() => {});